// extracted by mini-css-extract-plugin
module.exports = {"power-backup-B":"B_power-backup-B__RTW0b"};